module.exports = __webpack_public_path__ + "static/jenkins-b2527f0153d8d2167102e3cfae3fa108.svg";